import { ICategory } from 'api/types/_category';
import { Option } from 'api/types/_public';
import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_NORMAL } from 'common/toast';
import BreadCrumb from 'components/Common/BreadCrumb';
import DropdownOption from 'components/Common/DropdownOption';
import InputsRange from 'components/Common/InputsRange';
import LabelWrapper from 'components/Common/LabelWrapper';
import TooltipCustom from 'components/Common/TooltipCustom';
import { useRole } from 'components/Hooks/UserHooks';
import { useFormik } from "formik";
import { SYSTEM_CONFIG_KEY } from 'helpers/constans';
import { isHavePermissionRole, ROLES_FOR_APP } from 'helpers/role';
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Card, CardBody, Col, Container, Input, Label, Modal, ModalBody, ModalHeader, Row, Spinner } from "reactstrap";
import { getAllCategory, getConfiguration, putConfiguration } from 'store/thunks';
import * as Yup from "yup";


const Configuration = () => {
  const { t, i18n } = useTranslation();
  const { userPermissions } = useRole();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [categories, setCategories] = useState<Option[]>([]);

  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleSubmit = async (values: any) => {
    if (isLoading) {
      return;
    }
    setIsOpen((_prev) => true);
  };

  const handleSubmitConfiguration = async (values: any) => {
    try {
      if (isLoading) {
        return;
      }

      setIsLoading((_prev) => true);

      const _data_configs = {
        configs: [
          {
            key: SYSTEM_CONFIG_KEY.KEYWORD_TASK_QUERY_OLD_DATE_FROM,
            value: String(values?.query_old_date_from ?? ''),
            is_active: 1,
          },
          {
            key: SYSTEM_CONFIG_KEY.KEYWORD_TASK_QUERY_OLD_DATE_TO,
            value: String(values?.query_old_date_to ?? ''),
            is_active: 1,
          },
          {
            key: SYSTEM_CONFIG_KEY.KEYWORD_TASK_GROUP_1_1_TOTAL_CLICK_FROM,
            value: String(values?.group_1_1_total_click_from ?? ''),
            is_active: 1,
          },
          {
            key: SYSTEM_CONFIG_KEY.KEYWORD_TASK_GROUP_1_1_DAILY_SEARCH_VOLUME_FROM,
            value: String(values?.group_1_1_daily_search_volume_from ?? ''),
            is_active: 1,
          },
          {
            key: SYSTEM_CONFIG_KEY.KEYWORD_TASK_GROUP_1_1_PA_MEDIA_RANK_FROM,
            value: String(values?.group_1_1_pa_media_rank_from ?? ''),
            is_active: 1,
          },

          {
            key: SYSTEM_CONFIG_KEY.KEYWORD_TASK_GROUP_1_2_TOTAL_CLICK_FROM,
            value: String(values?.group_1_2_total_click_from ?? ''),
            is_active: 1,
          },
          {
            key: SYSTEM_CONFIG_KEY.KEYWORD_TASK_GROUP_1_2_DAILY_SEARCH_VOLUME_FROM,
            value: String(values?.group_1_2_daily_search_volume_from ?? ''),
            is_active: 1,
          },
          {
            key: SYSTEM_CONFIG_KEY.KEYWORD_TASK_GROUP_1_2_CATEGORY_ID,
            value: String(values?.group_1_2_category_id?.value || ''),
            is_active: 1,
          },
          {
            key: SYSTEM_CONFIG_KEY.KEYWORD_TASK_GROUP_1_CATEGORY_EXCLUSION_FILTER,
            value: JSON.stringify((values?.group_1_3_category_exclusion || [])?.map((item: any) => item?.value)),
            is_active: 1,
          },
          {
            key: SYSTEM_CONFIG_KEY.KEYWORD_TASK_GROUP_2_1_DAILY_SEARCH_VOLUME_FROM,
            value: String(values?.group_2_1_daily_search_volume_from ?? ''),
            is_active: 1,
          },
          {
            key: SYSTEM_CONFIG_KEY.KEYWORD_TASK_GROUP_2_1_PA_MEDIA_RANK_FROM,
            value: String(values?.group_2_1_pa_media_rank_from ?? ''),
            is_active: 1,
          },
          {
            key: SYSTEM_CONFIG_KEY.KEYWORD_TASK_GROUP_2_1_NEWS_SECTION_RANK_FROM,
            value: String(values?.group_2_1_news_section_rank_from ?? ''),
            is_active: 1,
          },
          {
            key: SYSTEM_CONFIG_KEY.KEYWORD_TASK_GROUP_2_1_NEWS_SECTION_RANK_TO,
            value: String(values?.group_2_1_news_section_rank_to ?? ''),
            is_active: 1,
          },

          {
            key: SYSTEM_CONFIG_KEY.KEYWORD_TASK_GROUP_2_2_DAILY_SEARCH_VOLUME_FROM,
            value: String(values?.group_2_2_daily_search_volume_from ?? ''),
            is_active: 1,
          },
          {
            key: SYSTEM_CONFIG_KEY.KEYWORD_TASK_GROUP_2_2_CATEGORY_ID,
            value: String(values?.group_2_2_category_id?.value || ''),
            is_active: 1,
          },
          {
            key: SYSTEM_CONFIG_KEY.KEYWORD_TASK_GROUP_2_2_NEWS_SECTION_RANK_FROM,
            value: String(values?.group_2_2_news_section_rank_from ?? ''),
            is_active: 1,
          },
          {
            key: SYSTEM_CONFIG_KEY.KEYWORD_TASK_GROUP_2_2_NEWS_SECTION_RANK_TO,
            value: String(values?.group_2_2_news_section_rank_to ?? ''),
            is_active: 1,
          },
          {
            key: SYSTEM_CONFIG_KEY.KEYWORD_TASK_GROUP_2_CATEGORY_EXCLUSION_FILTER,
            value: JSON.stringify((values?.group_2_3_category_exclusion || [])?.map((item: any) => item?.value)),
            is_active: 1,
          },
        ]
      };

      const [res1]: any = await Promise.all([putConfiguration(_data_configs)]);
      setIsOpen((_prev) => false);
      setIsLoading((_prev) => false);
      if (res1?.code === 200) {
        toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
      } else {
        toast(`${res1?.message || res1}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsOpen((_prev) => false);
      setIsLoading((_prev) => false);
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const validationSchema = Yup.object({

    category_1_id: Yup.object().shape({
      label: Yup.string(),
      value: Yup.string(),
    }).nullable(),
    category_2_id: Yup.object().shape({
      label: Yup.string(),
      value: Yup.string(),
    }).nullable(),

    query_old_date_from: Yup.string().nullable(),
    query_old_date_to: Yup.string().nullable(),

    group_1_1_daily_search_volume_from: Yup.string().nullable(),
    group_1_1_total_click_from: Yup.string().nullable(),
    group_1_1_pa_media_rank_from: Yup.string().nullable(),

    group_1_2_daily_search_volume_from: Yup.string().nullable(),
    group_1_2_total_click_from: Yup.string().nullable(),
    group_1_2_category_id: Yup.object().shape({
      label: Yup.string(),
      value: Yup.string(),
    }).nullable(),

    group_1_3_category_exclusion: Yup.array().of(Yup.object().shape({
      label: Yup.string(),
      value: Yup.string(),
    })).nullable(),

    group_2_1_daily_search_volume_from: Yup.string().nullable(),
    group_2_1_pa_media_rank_from: Yup.string().nullable(),
    group_2_1_news_section_rank_from: Yup.string().nullable(),
    group_2_1_news_section_rank_to: Yup.string().nullable(),

    group_2_2_daily_search_volume_from: Yup.string().nullable(),
    group_2_2_category_id: Yup.object().shape({
      label: Yup.string(),
      value: Yup.string(),
    }).nullable(),

    group_2_2_news_section_rank_from: Yup.string().nullable(),
    group_2_2_news_section_rank_to: Yup.string().nullable(),

    group_2_3_category_exclusion: Yup.array().of(Yup.object().shape({
      label: Yup.string(),
      value: Yup.string(),
    })).nullable(),
  });

  const formik = useFormik({
    initialValues: {

      category_1_id: null,
      category_2_id: null,

      query_old_date_from: '',
      query_old_date_to: '',

      group_1_1_daily_search_volume_from: '',
      group_1_1_total_click_from: '',
      group_1_1_pa_media_rank_from: '',

      group_1_2_daily_search_volume_from: '',
      group_1_2_total_click_from: '',
      group_1_2_category_id: null,

      group_1_3_category_exclusion: [],

      group_2_1_daily_search_volume_from: '',
      group_2_1_pa_media_rank_from: '',
      group_2_1_news_section_rank_from: '',
      group_2_1_news_section_rank_to: '',

      group_2_2_daily_search_volume_from: '',
      group_2_2_category_id: null,
      group_2_2_news_section_rank_from: '',
      group_2_2_news_section_rank_to: '',

      group_2_3_category_exclusion: [],

    },
    validationSchema,
    onSubmit: handleSubmit,
  });

  const setValueForm = (_configs: any) => {

    const _config_category_name = _configs?.category_name || '';

    const _config_query_old_date_from = _configs?.query_old_date_from;
    const _config_query_old_date_to = _configs?.query_old_date_to;

    const _config_group_1_1_daily_search_volume_from = _configs?.group_1_1_daily_search_volume_from;
    const _config_group_1_1_total_click_from = _configs?.group_1_1_total_click_from;
    const _config_group_1_1_pa_media_rank_from = _configs?.group_1_1_pa_media_rank_from;


    const _config_group_1_2_daily_search_volume_from = _configs?.group_1_2_daily_search_volume_from;
    const _config_group_1_2_total_click_from = _configs?.group_1_2_total_click_from;
    const _config_group_1_2_category_id = _configs?.group_1_2_category_id;

    const _config_group_1_3_category_exclusion_filter = _configs?.group_1_3_category_exclusion_filter;

    const _config_group_2_1_daily_search_volume_from = _configs?.group_2_1_daily_search_volume_from;
    const _config_group_2_1_pa_media_rank_from = _configs?.group_2_1_pa_media_rank_from;
    const _config_group_2_1_news_section_rank_from = _configs?.group_2_1_news_section_rank_from;
    const _config_group_2_1_news_section_rank_to = _configs?.group_2_1_news_section_rank_to;

    const _config_group_2_2_daily_search_volume_from = _configs?.group_2_2_daily_search_volume_from;
    const _config_group_2_2_category_id = _configs?.group_2_2_category_id;
    const _config_group_2_2_news_section_rank_from = _configs?.group_2_2_news_section_rank_from;
    const _config_group_2_2_news_section_rank_to = _configs?.group_2_2_news_section_rank_to;

    const _config_group_2_3_category_exclusion_filter = _configs?.group_2_3_category_exclusion_filter;


    formik?.setFieldValue('category_name', _config_category_name);
    formik?.setFieldValue('query_old_date_from', _config_query_old_date_from);
    formik?.setFieldValue('query_old_date_to', _config_query_old_date_to);

    formik?.setFieldValue('group_1_1_daily_search_volume_from', _config_group_1_1_daily_search_volume_from);
    formik?.setFieldValue('group_1_1_total_click_from', _config_group_1_1_total_click_from);
    formik?.setFieldValue('group_1_1_pa_media_rank_from', _config_group_1_1_pa_media_rank_from);

    formik?.setFieldValue('group_1_2_daily_search_volume_from', _config_group_1_2_daily_search_volume_from);
    formik?.setFieldValue('group_1_2_total_click_from', _config_group_1_2_total_click_from);
    formik?.setFieldValue('group_1_2_category_id', _config_group_1_2_category_id);
    formik?.setFieldValue('group_1_3_category_exclusion', _config_group_1_3_category_exclusion_filter);


    formik?.setFieldValue('group_2_1_daily_search_volume_from', _config_group_2_1_daily_search_volume_from);
    formik?.setFieldValue('group_2_1_pa_media_rank_from', _config_group_2_1_pa_media_rank_from);
    formik?.setFieldValue('group_2_1_news_section_rank_from', _config_group_2_1_news_section_rank_from);
    formik?.setFieldValue('group_2_1_news_section_rank_to', _config_group_2_1_news_section_rank_to);


    formik?.setFieldValue('group_2_2_daily_search_volume_from', _config_group_2_2_daily_search_volume_from);
    formik?.setFieldValue('group_2_2_category_id', _config_group_2_2_category_id);
    formik?.setFieldValue('group_2_2_news_section_rank_from', _config_group_2_2_news_section_rank_from);
    formik?.setFieldValue('group_2_2_news_section_rank_to', _config_group_2_2_news_section_rank_to);
    formik?.setFieldValue('group_2_3_category_exclusion', _config_group_2_3_category_exclusion_filter);

  };

  const handleCallAllOption = async () => {
    try {
      const [res1, res2]: any = await Promise.all([getAllCategory({}), getConfiguration({})]);
      const _cates = (res1?.data || [])?.map((_c: ICategory) => ({ value: `${_c?.id}`, label: _c?.name }));
      setCategories((_prev) => (_cates));

      if (res2?.data && res2?.data) {
        const _configs = res2?.data?.list || [];

        const _config_query_old_date_from = _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.KEYWORD_TASK_QUERY_OLD_DATE_FROM) || {};
        const _config_query_old_date_to = _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.KEYWORD_TASK_QUERY_OLD_DATE_TO) || {};

        const _config_group_1_1_daily_search_volume_from = _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.KEYWORD_TASK_GROUP_1_1_DAILY_SEARCH_VOLUME_FROM) || {};
        const _config_group_1_1_pa_media_rank_from = _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.KEYWORD_TASK_GROUP_1_1_PA_MEDIA_RANK_FROM) || {};
        const _config_group_1_1_total_click_from = _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.KEYWORD_TASK_GROUP_1_1_TOTAL_CLICK_FROM) || {};

        const _config_group_1_2_daily_search_volume_from = _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.KEYWORD_TASK_GROUP_1_2_DAILY_SEARCH_VOLUME_FROM) || {};
        const _config_group_1_2_total_click_from = _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.KEYWORD_TASK_GROUP_1_2_TOTAL_CLICK_FROM) || {};
        const _config_group_1_2_category_id = _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.KEYWORD_TASK_GROUP_1_2_CATEGORY_ID) || {};
        const _config_group_1_2_category_option = _cates?.find((item: any) => item?.value === `${_config_group_1_2_category_id?.value}`) || {};

        const _config_group_1_3_category_exclusion_filter = JSON.parse((_configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.KEYWORD_TASK_GROUP_1_CATEGORY_EXCLUSION_FILTER) || {})?.value || '[]');
        const _config_group_1_3_category_exclusion_filter_option = _cates?.filter((item: any) => (_config_group_1_3_category_exclusion_filter || []).includes(item?.value)) || [];

        const _config_group_2_1_daily_search_volume_from = _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.KEYWORD_TASK_GROUP_2_1_DAILY_SEARCH_VOLUME_FROM) || {};
        const _config_group_2_1_pa_media_rank_from = _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.KEYWORD_TASK_GROUP_2_1_PA_MEDIA_RANK_FROM) || {};
        const _config_group_2_1_news_section_rank_from = _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.KEYWORD_TASK_GROUP_2_1_NEWS_SECTION_RANK_FROM) || {};
        const _config_group_2_1_news_section_rank_to = _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.KEYWORD_TASK_GROUP_2_1_NEWS_SECTION_RANK_TO) || {};


        const _config_group_2_2_daily_search_volume_from = _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.KEYWORD_TASK_GROUP_2_2_DAILY_SEARCH_VOLUME_FROM) || {};
        const _config_group_2_2_news_section_rank_from = _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.KEYWORD_TASK_GROUP_2_2_NEWS_SECTION_RANK_FROM) || {};
        const _config_group_2_2_news_section_rank_to = _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.KEYWORD_TASK_GROUP_2_2_NEWS_SECTION_RANK_TO) || {};
        const _config_group_2_2_category_id = _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.KEYWORD_TASK_GROUP_2_2_CATEGORY_ID) || {};
        const _config_group_2_2_category_option = _cates?.find((item: any) => item?.value === `${_config_group_2_2_category_id?.value}`) || {};

        const _config_group_2_3_category_exclusion_filter = JSON.parse((_configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.KEYWORD_TASK_GROUP_2_CATEGORY_EXCLUSION_FILTER) || {})?.value || '[]');
        const _config_group_2_3_category_exclusion_filter_option = _cates?.filter((item: any) => (_config_group_2_3_category_exclusion_filter || []).includes(item?.value)) || [];

        setValueForm({
          query_old_date_from: _config_query_old_date_from?.value,
          query_old_date_to: _config_query_old_date_to?.value,

          group_1_1_daily_search_volume_from: _config_group_1_1_daily_search_volume_from?.value,
          group_1_1_pa_media_rank_from: _config_group_1_1_pa_media_rank_from?.value,
          group_1_1_total_click_from: _config_group_1_1_total_click_from?.value,

          group_1_2_daily_search_volume_from: _config_group_1_2_daily_search_volume_from?.value,
          group_1_2_total_click_from: _config_group_1_2_total_click_from?.value,
          group_1_2_category_id: _config_group_1_2_category_option,

          group_2_1_daily_search_volume_from: _config_group_2_1_daily_search_volume_from?.value,
          group_2_1_pa_media_rank_from: _config_group_2_1_pa_media_rank_from?.value,
          group_2_1_news_section_rank_from: _config_group_2_1_news_section_rank_from?.value,
          group_2_1_news_section_rank_to: _config_group_2_1_news_section_rank_to?.value,

          group_2_2_daily_search_volume_from: _config_group_2_2_daily_search_volume_from?.value,
          group_2_2_news_section_rank_from: _config_group_2_2_news_section_rank_from?.value,
          group_2_2_news_section_rank_to: _config_group_2_2_news_section_rank_to?.value,
          group_2_2_category_id: _config_group_2_2_category_option,

          group_1_3_category_exclusion_filter: _config_group_1_3_category_exclusion_filter_option,
          group_2_3_category_exclusion_filter: _config_group_2_3_category_exclusion_filter_option,

        });
      }
    } catch (error: any) {
      return error;
    }
  };


  const categoryExclusionFilterGroup1 = useMemo(() => {
    const group_1_3_category_exclusion = (formik.values.group_1_3_category_exclusion || [])?.map((item: any) => item?.value);
    return categories?.filter((item: any) => !group_1_3_category_exclusion?.includes(item?.value));
  }, [categories, formik.values.group_1_3_category_exclusion]);

  const categoryExclusionFilterGroup2 = useMemo(() => {
    const group_2_3_category_exclusion = (formik.values.group_2_3_category_exclusion || [])?.map((item: any) => item?.value);
    return categories?.filter((item: any) => !group_2_3_category_exclusion?.includes(item?.value));
  }, [categories, formik.values.group_2_3_category_exclusion]);

  useEffect(() => {
    handleCallAllOption();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    document.title = `${t('Configuration')} - ${t('Task Keyword')} | PRESS Ai`;
    document.body.classList.remove('vertical-sidebar-enable');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t('Task Keyword')} pageTitle={t('Configuration')} />
          <Row>
            {isHavePermissionRole(ROLES_FOR_APP.CONFIGURATION_BOOSTING_NEWS, userPermissions) && (
              <Col lg={12}>
                <Card id="customerList" style={{ boxShadow: '0px 3px 4px 0px rgba(0, 0, 0, 0.03)', minHeight: '75dvh' }}>
                  <CardBody className="pt-3 mb-3">
                    <form onSubmit={formik.handleSubmit}>
                      <div style={{ maxWidth: '100%', margin: '0 auto' }}>
                        <Row>
                          <Col md={4} className="px-4">
                            <Row>
                              <div className="position-relative mb-3 mt-1 mt-md-0" style={{ border: '1px dashed var(--vz-primary)', borderRadius: '4px', padding: '10px' }}>
                                <span className="text-primary position-absolute fs-13 px-1" style={{ backgroundColor: "var(--vz-secondary-bg)", top: '0px', transform: 'translateY(-50%)' }}>{t('Task Keyword')}</span>
                                <Col sm={12} md={12} xl={12} className='mt-2 '>
                                  <Label htmlFor="query_old_date_from" className="form-label">{t('Published at (Previous Period)')} <span className="text-danger"> *</span>
                                    <TooltipCustom
                                      title={t("Keywords of the articles delivered during the selected period.")}
                                      className="d-inline-block vertical-align-middle ms-1"
                                      style={{ transform: 'translateY(1px)' }}
                                    >
                                      <i className="ri-question-line align-bottom text-secondary" ></i>
                                    </TooltipCustom>
                                  </Label>
                                  <InputsRange
                                    nameFrom="from"
                                    nameTo="to"
                                    valueFrom={formik?.values?.query_old_date_from}
                                    valueTo={formik?.values?.query_old_date_to}
                                    placeholderFrom={`${t('Published at (Previous Period) (Start)')}...`}
                                    placeholderTo={`${t('Published at (Previous Period) (End)')}...`}
                                    labelFrom={`${t('Published at (Previous Period) (Start)')}`}
                                    labelTo={`${t('Published at (Previous Period) (End)')}`}
                                    isTypeNumber={true}
                                    onChangeFrom={(val) => formik.setFieldValue("query_old_date_from", val)}
                                    onChangeTo={(val) => formik.setFieldValue("query_old_date_to", val)}
                                  />
                                </Col>
                              </div>
                            </Row>
                          </Col>

                          <Col md={8} className="px-4">
                            <Row>
                              <div className="mb-4 position-relative pt-3" style={{ border: '1px dashed var(--vz-primary)', borderRadius: '4px', padding: '10px' }}>
                                <span className="text-primary position-absolute fs-13 px-1" style={{ backgroundColor: "var(--vz-secondary-bg)", top: '0px', transform: 'translateY(-50%)' }}>{t('Group')} 1</span>

                                <div className="mb-4 mt-1 position-relative" style={{ border: '1px dashed var(--vz-secondary)', borderRadius: '4px', padding: '10px' }}>
                                  <span className="text-secondary position-absolute fs-13 px-1" style={{ backgroundColor: "var(--vz-secondary-bg)", top: '0px', transform: 'translateY(-50%)' }}>{t('Group')} 1.1</span>
                                  <Row>
                                    <Col sm={4} md={4} xl={4} className='mt-2 '>
                                      <Label htmlFor="group_1_1_pa_media_rank_from" className="form-label">{t('PA Media Ranking')} <span className="text-danger"> *</span>
                                        <TooltipCustom
                                          title={t("Keywords ranked equal to or higher than the specified rank.")}
                                          className="d-inline-block vertical-align-middle ms-1"
                                          style={{ transform: 'translateY(1px)' }}
                                        >
                                          <i className="ri-question-line align-bottom text-secondary" ></i>
                                        </TooltipCustom>
                                      </Label>
                                      <Input
                                        className="form-control"
                                        id="group_1_1_pa_media_rank_from"
                                        name="group_1_1_pa_media_rank_from"
                                        type="text"
                                        value={formik?.values?.group_1_1_pa_media_rank_from ?? ''}
                                        placeholder={t('PA Media Ranking')}
                                        autoComplete='off'
                                        onChange={(event: any) => {
                                          const input = event.target.value;
                                          const onlyNumbers = input.replace(/\D/g, "");
                                          const s = onlyNumbers;
                                          formik.setFieldValue("group_1_1_pa_media_rank_from", s);
                                        }}
                                      />
                                      {formik.touched.group_1_1_pa_media_rank_from && formik.errors.group_1_1_pa_media_rank_from ? (
                                        <div className="text-danger mt-2">{formik.errors.group_1_1_pa_media_rank_from}</div>
                                      ) : null}
                                    </Col>
                                    <Col sm={4} md={4} xl={4} className='mt-2 '>
                                      <Label htmlFor="group_1_1_daily_search_volume_from" className="form-label">{t('Daily Search Volume')} <span className="text-danger"> *</span>
                                        <TooltipCustom
                                          title={t("Only generate news for keywords with a daily search volume above the specified threshold.")}
                                          className="d-inline-block vertical-align-middle ms-1"
                                          style={{ transform: 'translateY(1px)' }}
                                        >
                                          <i className="ri-question-line align-bottom text-secondary" ></i>
                                        </TooltipCustom>
                                      </Label>
                                      <Input
                                        className="form-control"
                                        id="group_1_1_daily_search_volume_from"
                                        name="group_1_1_daily_search_volume_from"
                                        type="text"
                                        value={formik?.values?.group_1_1_daily_search_volume_from ?? ''}
                                        placeholder={t('Daily Search Volume')}
                                        autoComplete='off'
                                        onChange={(event: any) => {
                                          const input = event.target.value;
                                          const onlyNumbers = input.replace(/\D/g, "");
                                          const s = onlyNumbers;
                                          formik.setFieldValue("group_1_1_daily_search_volume_from", s);
                                        }}
                                      />
                                      {formik.touched.group_1_1_daily_search_volume_from && formik.errors.group_1_1_daily_search_volume_from ? (
                                        <div className="text-danger mt-2">{formik.errors.group_1_1_daily_search_volume_from}</div>
                                      ) : null}
                                    </Col>
                                    <Col sm={4} md={4} xl={4} className='mt-2 '>
                                      <Label htmlFor="group_1_1_total_click_from" className="form-label">{t('Click')} <span className="text-danger"> *</span>
                                        <TooltipCustom
                                          title={t("Keywords ranked equal to or higher than the specified clicks.")}
                                          className="d-inline-block vertical-align-middle ms-1"
                                          style={{ transform: 'translateY(1px)' }}
                                        >
                                          <i className="ri-question-line align-bottom text-secondary" ></i>
                                        </TooltipCustom>
                                      </Label>
                                      <Input
                                        className="form-control"
                                        id="group_1_1_total_click_from"
                                        name="group_1_1_total_click_from"
                                        type="text"
                                        value={formik?.values?.group_1_1_total_click_from ?? ''}
                                        placeholder={t('Click')}
                                        autoComplete='off'
                                        onChange={(event: any) => {
                                          const input = event.target.value;
                                          const onlyNumbers = input.replace(/\D/g, "");
                                          const s = onlyNumbers;
                                          formik.setFieldValue("group_1_1_total_click_from", s);
                                        }}
                                      />
                                      {formik.touched.group_1_1_total_click_from && formik.errors.group_1_1_total_click_from ? (
                                        <div className="text-danger mt-2">{formik.errors.group_1_1_total_click_from}</div>
                                      ) : null}
                                    </Col>

                                  </Row>
                                </div>


                                <div className="mb-2 position-relative" style={{ border: '1px dashed var(--vz-secondary)', borderRadius: '4px', padding: '10px' }}>
                                  <span className="text-secondary position-absolute fs-13 px-1" style={{ backgroundColor: "var(--vz-secondary-bg)", top: '0px', transform: 'translateY(-50%)' }}>{t('Group')} 1.2</span>
                                  <Row>
                                    <Col sm={4} md={4} xl={4} className='mt-2 '>
                                      <Label htmlFor="group_1_2_category_id" className="form-label">{t('Category')} <span className="text-danger"> *</span>
                                      </Label>
                                      <DropdownOption
                                        name="group_1_2_category_id"
                                        dataList={categories || []}
                                        placeholder={`${t("Category")}...`}
                                        className={`dropdown-status-rounded z-hight mb-3 mb-lg-2 mb-xxl-1`}
                                        classNamePrefix="name-prefix"
                                        style={{ width: '100%' }}
                                        initialValue={formik?.values?.group_1_2_category_id}
                                        onChangeSelect={(e: any) => {
                                          formik.setFieldValue("group_1_2_category_id", e);
                                        }}
                                      />
                                      {formik.touched.group_1_2_category_id && formik.errors.group_1_2_category_id ? (
                                        <div className="text-danger mt-2">{formik.errors.group_1_2_category_id}</div>
                                      ) : null}
                                    </Col>

                                    <Col sm={4} md={4} xl={4} className='mt-2 '>
                                      <Label htmlFor="group_1_2_daily_search_volume_from" className="form-label">{t('Daily Search Volume')} <span className="text-danger"> *</span>
                                        <TooltipCustom
                                          title={t("Only generate news for keywords with a daily search volume above the specified threshold.")}
                                          className="d-inline-block vertical-align-middle ms-1"
                                          style={{ transform: 'translateY(1px)' }}
                                        >
                                          <i className="ri-question-line align-bottom text-secondary" ></i>
                                        </TooltipCustom>
                                      </Label>
                                      <Input
                                        className="form-control"
                                        id="group_1_2_daily_search_volume_from"
                                        name="group_1_2_daily_search_volume_from"
                                        type="text"
                                        value={formik?.values?.group_1_2_daily_search_volume_from ?? ''}
                                        placeholder={t('Daily Search Volume')}
                                        autoComplete='off'
                                        onChange={(event: any) => {
                                          const input = event.target.value;
                                          const onlyNumbers = input.replace(/\D/g, "");
                                          const s = onlyNumbers;
                                          formik.setFieldValue("group_1_2_daily_search_volume_from", s);
                                        }}
                                      />
                                      {formik.touched.group_1_2_daily_search_volume_from && formik.errors.group_1_2_daily_search_volume_from ? (
                                        <div className="text-danger mt-2">{formik.errors.group_1_2_daily_search_volume_from}</div>
                                      ) : null}
                                    </Col>

                                    <Col sm={4} md={4} xl={4} className='mt-2 '>
                                      <Label htmlFor="group_1_2_total_click_from" className="form-label">{t('Click')} <span className="text-danger"> *</span>
                                        <TooltipCustom
                                          title={t("Keywords ranked equal to or higher than the specified clicks.")}
                                          className="d-inline-block vertical-align-middle ms-1"
                                          style={{ transform: 'translateY(1px)' }}
                                        >
                                          <i className="ri-question-line align-bottom text-secondary" ></i>
                                        </TooltipCustom>
                                      </Label>
                                      <Input
                                        className="form-control"
                                        id="group_1_2_total_click_from"
                                        name="group_1_2_total_click_from"
                                        type="text"
                                        value={formik?.values?.group_1_2_total_click_from ?? ''}
                                        placeholder={t('Click')}
                                        autoComplete='off'
                                        onChange={(event: any) => {
                                          const input = event.target.value;
                                          const onlyNumbers = input.replace(/\D/g, "");
                                          const s = onlyNumbers;
                                          formik.setFieldValue("group_1_2_total_click_from", s);
                                        }}
                                      />
                                      {formik.touched.group_1_2_total_click_from && formik.errors.group_1_2_total_click_from ? (
                                        <div className="text-danger mt-2">{formik.errors.group_1_2_total_click_from}</div>
                                      ) : null}
                                    </Col>
                                  </Row>
                                </div>

                                <div className="mb-2 mt-4 position-relative" style={{ border: '1px dashed var(--vz-secondary)', borderRadius: '4px', padding: '10px' }}>
                                  <span className="text-secondary position-absolute fs-13 px-1" style={{ backgroundColor: "var(--vz-secondary-bg)", top: '0px', transform: 'translateY(-50%)' }}>{t('Category Exclusion Filter')}</span>
                                  <Row>
                                    <Col sm={4} md={4} xl={4} className='mt-3'>
                                      <LabelWrapper label={t('Category')} isShow={true}>
                                        <DropdownOption
                                          name="category_1_id"
                                          dataList={(categoryExclusionFilterGroup1 || [])}
                                          placeholder={`${t("Category")}...`}
                                          className={`dropdown-status-rounded z-hight mb-3 mb-lg-2 mb-xxl-1`}
                                          classNamePrefix="name-prefix"
                                          style={{ width: '100%' }}
                                          initialValue={formik?.values?.category_1_id ?? null}
                                          onChangeSelect={(e: any) => {
                                            formik.setFieldValue("category_1_id", e);
                                          }}
                                        />
                                      </LabelWrapper>
                                      {formik.touched.category_1_id && formik.errors.category_1_id ? (
                                        <div className="text-danger mt-2">{formik.errors.category_1_id}</div>
                                      ) : null}
                                    </Col>
                                    <Col sm={8} md={8} xl={8} className='mt-0 mt-md-3'>
                                      <button
                                        style={{ width: '210px' }}
                                        type="button"
                                        disabled={(isLoading)}
                                        className="btn btn-light fs-14"
                                        onClick={() => {
                                          if ((formik?.values?.category_1_id as any)?.value) {
                                            if ((formik?.values?.group_1_3_category_exclusion || []).find((item: any) => item.value === (formik?.values?.category_1_id as any)?.value)) {
                                              return;
                                            }
                                            const val = [...(formik?.values?.group_1_3_category_exclusion || []), (formik?.values?.category_1_id as any)];
                                            formik.setFieldValue("group_1_3_category_exclusion", val);
                                            formik.setFieldValue("category_1_id", null);
                                          }
                                        }}
                                      >
                                        <i className="ri-add-line align-bottom me-1"></i>
                                        {t('Add Exclusion Category')}
                                      </button>
                                    </Col>

                                    <Col sm={12} className='mt-2 pb-1'>
                                      <div style={{ maxHeight: '60dvh' }} className="overflow-y-auto color-scrollbar-os">
                                        <div className="d-flex gap-2 flex-wrap">
                                          {(formik?.values?.group_1_3_category_exclusion || [])?.map((item: any) => (
                                            <button type="button" className="btn px-3 px-md-4 py-btn-section bg-primary-subtle text-primary" key={item?.value}
                                              onClick={() => {
                                                const val = (formik?.values?.group_1_3_category_exclusion || [])?.filter((i: any) => i.value !== item.value);
                                                formik.setFieldValue("group_1_3_category_exclusion", val);
                                              }}
                                            >
                                              <div className="d-flex align-items-center align-middle">
                                                <span className="me-1">{item?.label}</span>
                                                <span style={{ transform: 'translateY(2px)' }}><i className="ri-close-line align-bottom"></i></span>
                                              </div>
                                            </button>
                                          ))}
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>
                                </div>
                              </div>

                              <div className="mb-3 position-relative pt-4" style={{ border: '1px dashed var(--vz-primary)', borderRadius: '4px', padding: '10px' }}>
                                <span className="text-primary position-absolute fs-13 px-1" style={{ backgroundColor: "var(--vz-secondary-bg)", top: '0px', transform: 'translateY(-50%)' }}>{t('Group')} 2</span>

                                <div className="mb-4 position-relative" style={{ border: '1px dashed var(--vz-secondary)', borderRadius: '4px', padding: '10px' }}>
                                  <span className="text-secondary position-absolute fs-13 px-1" style={{ backgroundColor: "var(--vz-secondary-bg)", top: '0px', transform: 'translateY(-50%)' }}>{t('Group')} 2.1</span>

                                  <Row>
                                    <Col sm={6} md={6} xl={6} className='mt-2 '>
                                      <Label htmlFor="group_2_1_pa_media_rank_from" className="form-label">{t('PA Media Ranking')} <span className="text-danger"> *</span>
                                        <TooltipCustom
                                          title={t("Keywords ranked equal to or higher than the specified rank.")}
                                          className="d-inline-block vertical-align-middle ms-1"
                                          style={{ transform: 'translateY(1px)' }}
                                        >
                                          <i className="ri-question-line align-bottom text-secondary" ></i>
                                        </TooltipCustom>
                                      </Label>
                                      <Input
                                        className="form-control"
                                        id="group_2_1_pa_media_rank_from"
                                        name="group_2_1_pa_media_rank_from"
                                        type="text"
                                        value={formik?.values?.group_2_1_pa_media_rank_from ?? ''}
                                        placeholder={t('PA Media Ranking')}
                                        autoComplete='off'
                                        onChange={(event: any) => {
                                          const input = event.target.value;
                                          const onlyNumbers = input.replace(/\D/g, "");
                                          const s = onlyNumbers;
                                          formik.setFieldValue("group_2_1_pa_media_rank_from", s);
                                        }}
                                      />
                                      {formik.touched.group_2_1_pa_media_rank_from && formik.errors.group_2_1_pa_media_rank_from ? (
                                        <div className="text-danger mt-2">{formik.errors.group_2_1_pa_media_rank_from}</div>
                                      ) : null}
                                    </Col>
                                    <Col sm={6} md={6} xl={6} className='mt-2 '>
                                      <Label htmlFor="group_2_1_daily_search_volume_from" className="form-label">{t('Daily Search Volume')} <span className="text-danger"> *</span>
                                        <TooltipCustom
                                          title={t("Only generate news for keywords with a daily search volume above the specified threshold.")}
                                          className="d-inline-block vertical-align-middle ms-1"
                                          style={{ transform: 'translateY(1px)' }}
                                        >
                                          <i className="ri-question-line align-bottom text-secondary" ></i>
                                        </TooltipCustom>
                                      </Label>
                                      <Input
                                        className="form-control"
                                        id="group_2_1_daily_search_volume_from"
                                        name="group_2_1_daily_search_volume_from"
                                        type="text"
                                        value={formik?.values?.group_2_1_daily_search_volume_from ?? ''}
                                        placeholder={t('Daily Search Volume')}
                                        autoComplete='off'
                                        onChange={(event: any) => {
                                          const input = event.target.value;
                                          const onlyNumbers = input.replace(/\D/g, "");
                                          const s = onlyNumbers;
                                          formik.setFieldValue("group_2_1_daily_search_volume_from", s);
                                        }}
                                      />
                                      {formik.touched.group_2_1_daily_search_volume_from && formik.errors.group_2_1_daily_search_volume_from ? (
                                        <div className="text-danger mt-2">{formik.errors.group_2_1_daily_search_volume_from}</div>
                                      ) : null}
                                    </Col>



                                    <Col sm={12} md={12} xl={12} className='mt-2 '>
                                      <Label htmlFor="source_exposure_period" className="form-label">{t('News Section Ranking')} <span className="text-danger"> *</span>
                                      </Label>
                                      <InputsRange
                                        nameFrom="from"
                                        nameTo="to"
                                        valueFrom={formik?.values?.group_2_1_news_section_rank_from}
                                        valueTo={formik?.values?.group_2_1_news_section_rank_to}
                                        placeholderFrom={`${t('News Section Ranking (Start)')}...`}
                                        placeholderTo={`${t('News Section Ranking (End)')}...`}
                                        labelFrom={`${t('News Section Ranking (Start)')}`}
                                        labelTo={`${t('News Section Ranking (End)')}`}
                                        isTypeNumber={true}
                                        onChangeFrom={(val) => formik.setFieldValue("group_2_1_news_section_rank_from", val)}
                                        onChangeTo={(val) => formik.setFieldValue("group_2_1_news_section_rank_to", val)}
                                      />
                                    </Col>
                                  </Row>

                                </div>


                                <div className="mb-2 position-relative" style={{ border: '1px dashed var(--vz-secondary)', borderRadius: '4px', padding: '10px' }}>
                                  <span className="text-secondary position-absolute fs-13 px-1" style={{ backgroundColor: "var(--vz-secondary-bg)", top: '0px', transform: 'translateY(-50%)' }}>{t('Group')} 2.2</span>

                                  <Row>
                                    <Col sm={6} md={6} xl={6} className='mt-2 '>
                                      <Label htmlFor="group_2_2_category_id" className="form-label">{t('Category')} <span className="text-danger"> *</span>
                                      </Label>
                                      <DropdownOption
                                        name="group_2_2_category_id"
                                        dataList={categories || []}
                                        placeholder={`${t("Category")}...`}
                                        className={`dropdown-status-rounded z-hight mb-3 mb-lg-2 mb-xxl-1`}
                                        classNamePrefix="name-prefix"
                                        style={{ width: '100%' }}
                                        initialValue={formik?.values?.group_2_2_category_id}
                                        onChangeSelect={(e: any) => {
                                          formik.setFieldValue("group_2_2_category_id", e);
                                        }}
                                      />
                                      {formik.touched.group_2_2_category_id && formik.errors.group_2_2_category_id ? (
                                        <div className="text-danger mt-2">{formik.errors.group_2_2_category_id}</div>
                                      ) : null}
                                    </Col>

                                    <Col sm={6} md={6} xl={6} className='mt-2 '>
                                      <Label htmlFor="group_2_2_daily_search_volume_from" className="form-label">{t('Daily Search Volume')} <span className="text-danger"> *</span>
                                        <TooltipCustom
                                          title={t("Only generate news for keywords with a daily search volume above the specified threshold.")}
                                          className="d-inline-block vertical-align-middle ms-1"
                                          style={{ transform: 'translateY(1px)' }}
                                        >
                                          <i className="ri-question-line align-bottom text-secondary" ></i>
                                        </TooltipCustom>
                                      </Label>
                                      <Input
                                        className="form-control"
                                        id="group_2_2_daily_search_volume_from"
                                        name="group_2_2_daily_search_volume_from"
                                        type="text"
                                        value={formik?.values?.group_2_2_daily_search_volume_from ?? ''}
                                        placeholder={t('Daily Search Volume')}
                                        autoComplete='off'
                                        onChange={(event: any) => {
                                          const input = event.target.value;
                                          const onlyNumbers = input.replace(/\D/g, "");
                                          const s = onlyNumbers;
                                          formik.setFieldValue("group_2_2_daily_search_volume_from", s);
                                        }}
                                      />
                                      {formik.touched.group_2_2_daily_search_volume_from && formik.errors.group_2_2_daily_search_volume_from ? (
                                        <div className="text-danger mt-2">{formik.errors.group_2_2_daily_search_volume_from}</div>
                                      ) : null}
                                    </Col>

                                    <Col sm={12} md={12} xl={12} className='mt-2 '>
                                      <Label htmlFor="source_exposure_period" className="form-label">{t('News Section Ranking')} <span className="text-danger"> *</span>
                                      </Label>
                                      <InputsRange
                                        nameFrom="from"
                                        nameTo="to"
                                        valueFrom={formik?.values?.group_2_2_news_section_rank_from}
                                        valueTo={formik?.values?.group_2_2_news_section_rank_to}
                                        placeholderFrom={`${t('News Section Ranking (Start)')}...`}
                                        placeholderTo={`${t('News Section Ranking (End)')}...`}
                                        labelFrom={`${t('News Section Ranking (Start)')}`}
                                        labelTo={`${t('News Section Ranking (End)')}`}
                                        isTypeNumber={true}
                                        onChangeFrom={(val) => formik.setFieldValue("group_2_2_news_section_rank_from", val)}
                                        onChangeTo={(val) => formik.setFieldValue("group_2_2_news_section_rank_to", val)}
                                      />
                                    </Col>
                                  </Row>

                                </div>

                                <div className="mb-2 mt-4 position-relative" style={{ border: '1px dashed var(--vz-secondary)', borderRadius: '4px', padding: '10px' }}>
                                  <span className="text-secondary position-absolute fs-13 px-1" style={{ backgroundColor: "var(--vz-secondary-bg)", top: '0px', transform: 'translateY(-50%)' }}>{t('Category Exclusion Filter')}</span>
                                  <Row>
                                    <Col sm={4} md={4} xl={4} className='mt-3'>
                                      <LabelWrapper label={t('Category')} isShow={true}>
                                        <DropdownOption
                                          name="category_2_id"
                                          dataList={(categoryExclusionFilterGroup2 || [])}
                                          placeholder={`${t("Category")}...`}
                                          className={`dropdown-status-rounded z-hight mb-3 mb-lg-2 mb-xxl-1`}
                                          classNamePrefix="name-prefix"
                                          style={{ width: '100%' }}
                                          initialValue={formik?.values?.category_2_id ?? null}
                                          onChangeSelect={(e: any) => {
                                            formik.setFieldValue("category_2_id", e);
                                          }}
                                        />
                                      </LabelWrapper>
                                      {formik.touched.category_2_id && formik.errors.category_2_id ? (
                                        <div className="text-danger mt-2">{formik.errors.category_2_id}</div>
                                      ) : null}
                                    </Col>
                                    <Col sm={8} md={8} xl={8} className='mt-0 mt-md-3'>
                                      <button
                                        style={{ width: '210px' }}
                                        type="button"
                                        disabled={(isLoading)}
                                        className="btn btn-light fs-14"
                                        onClick={() => {
                                          if ((formik?.values?.category_2_id as any)?.value) {
                                            if ((formik?.values?.group_2_3_category_exclusion || []).find((item: any) => item.value === (formik?.values?.category_2_id as any)?.value)) {
                                              return;
                                            }
                                            const val = [...(formik?.values?.group_2_3_category_exclusion || []), (formik?.values?.category_2_id as any)];
                                            formik.setFieldValue("group_2_3_category_exclusion", val);
                                            formik.setFieldValue("category_2_id", null);
                                          }
                                        }}
                                      >
                                        <i className="ri-add-line align-bottom me-1"></i>
                                        {t('Add Exclusion Category')}
                                      </button>
                                    </Col>

                                    <Col sm={12} className='mt-2 pb-1'>
                                      <div style={{ maxHeight: '60dvh' }} className="overflow-y-auto color-scrollbar-os">
                                        <div className="d-flex gap-2 flex-wrap">
                                          {(formik?.values?.group_2_3_category_exclusion || [])?.map((item: any) => (
                                            <button type="button" className=" btn px-3 px-md-4 py-btn-section bg-primary-subtle text-primary" key={item?.value}
                                              onClick={() => {
                                                const val = (formik?.values?.group_2_3_category_exclusion || [])?.filter((i: any) => i.value !== item.value);
                                                formik.setFieldValue("group_2_3_category_exclusion", val);
                                              }}
                                            >
                                              <div className="d-flex align-items-center align-middle">
                                                <span className="me-1">{item?.label}</span>
                                                <span style={{ transform: 'translateY(2px)' }}><i className="ri-close-line align-bottom"></i></span>
                                              </div>
                                            </button>
                                          ))}
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>
                                </div>

                              </div>
                            </Row>
                          </Col>
                          <Col sm={12} md={12} xl={12} className='mt-4 pt-1 text-end'>
                            <button
                              style={{ width: '150px' }}
                              type="submit"
                              disabled={(isLoading)}
                              className="btn btn-primary fs-14 rounded-pill">
                              {<>{t('Button Update')}</>}
                            </button>
                          </Col>
                        </Row>
                      </div>
                    </form>
                  </CardBody>
                </Card>
              </Col>
            )}
          </Row>
        </Container>

        <Modal
          isOpen={!!isOpen}
          centered={true}
          // size="lg"
          toggle={() => setIsOpen(false)}
          keyboard={true}
        >
          <ModalHeader>
            {t('Configuration')}
          </ModalHeader>
          <ModalBody className="">
            <div className="row g-4">
              <Col sm={12}>
                <div className="row g-3">
                  <div className="mt-3 text-center">
                    <h6 className="mb-2 fs-19 text-center mt-1">
                      {t("Are you sure you want to update this?")}
                    </h6>
                    <p className="fs-15 mb-4 d-flex justify-content-center align-items-start align-items-sm-center text-center ">
                      {t('After confirming the update action, the data will be updated. Do you want to proceed with the update action.')}
                    </p>
                    <div className="d-flex gap-3 mt-2 justify-content-center">
                      <button
                        className="btn btn-primary rounded-pill fs-14"
                        type="button"
                        color="light"
                        onClick={() => handleSubmitConfiguration(formik?.values)}
                        style={{ width: '120px' }}
                      >
                        {(isLoading) ? <Spinner size="sm me-2" ></Spinner> : <>{t('Button Update')}</>}
                      </button>
                      <button
                        className="btn btn-secondary rounded-pill fs-14 ms-2"
                        type="button"
                        color="light"
                        onClick={() => setIsOpen(false)}
                        style={{ width: '120px' }}
                      >
                        {t("Button Close")}
                      </button>
                    </div>
                  </div>
                </div>
              </Col>
            </div>
          </ModalBody>
        </Modal >

        <ToastContainer closeButton={false} newestOnTop={false} pauseOnFocusLoss autoClose={2000} limit={2} />

      </div >
    </React.Fragment >
  );
};

export default Configuration;